// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E5TS","label":"styles_label__3RKU-"};